import { MaterialIcon } from "@website/icons/material";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { Button } from "@website/ui/button";
import { CollapsibleText } from "@website/ui/collapsible-text";
import { deepCompare } from "@website/utils/deep-compare";
import { ReserveComment } from "@website/widget/reserve-comment";
import { ReserveCommentPopup } from "@website/widget/reserve-comments-layout/reserve-comment-popup";
import { ReserveCommentsPropertiesLayoutTypes } from "@website/widget/reserve-comments-layout/reserve-comments-layout.types";
import isEmpty from "lodash-es/isEmpty";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { memo, useCallback } from "react";

const Component = (properties: ReserveCommentsPropertiesLayoutTypes) => {
  const router = useRouter();
  const {
    hotelTitle,
    comments,
    lastReviewId,
    onLoadMore,
    isLoading,
    rate,
    onLoadFilter,
    filters
  } = properties;

  const modal_key = "modal";
  const open = router.query[modal_key] === "comments";

  const toggleModal = useCallback(
    (statue: boolean, isCta?: boolean) => {
      if (process.env.NEXT_PUBLIC_BASE_PATHNAME?.includes("رزرو-هتل"))
        addEventToTracking(
          isCta
            ? USER_TRACKING_EVENTS.REVIEWS_BOTTOM_CTA_VIEWED
            : USER_TRACKING_EVENTS.REVIEWS_SECTION_OPENED,
          {
            product: "dom-hotel"
          }
        );
      if (statue)
        return router.replace(
          {
            pathname: router.pathname,
            query: { ...router.query, [modal_key]: "comments" }
          },
          undefined,
          { shallow: true, scroll: false }
        );

      if (onLoadFilter && !isEmpty(filters)) {
        onLoadFilter(filters);
      }
      if (onLoadFilter) {
        onLoadFilter({}, true);
      }
      return router.replace(
        {
          pathname: router.pathname,
          query: {
            ...omit(
              router?.query,
              "popover",
              "modal",
              "order_by",
              Object.keys(router?.query).filter((item) =>
                item.startsWith("filter_")
              )
            )
          }
        },
        undefined,
        { shallow: true, scroll: false }
      );
    },

    [filters, onLoadFilter, router]
  );

  if (comments?.length === 0 && !router?.query?.["modal"]) return null;

  return (
    <div className="flex flex-col gap-6" id="hotel_comments">
      {rate?.aiSummary && (
        <div className="bg-dim-background text-subtitle-2 flex flex-col gap-2 rounded-lg px-3 py-4">
          <CollapsibleText
            ariaLabel="description"
            className="text-on-surface-high-emphasis"
            collapsedClassName="h-[117px]"
            content={rate?.aiSummary}
            eventKey={USER_TRACKING_EVENTS?.AI_SUMMARY_COMMENTS as const}
            isHtml
          />
          <div className="bg-transparent-secondary text-caption flex flex-row items-center gap-1 rounded-lg p-2">
            <MaterialIcon
              className="text-secondary"
              name="edit"
              variant="outlined"
            />
            <span>
              برگرفته از نظرات مهمانان واقعی که توسط هوش مصنوعی خلاصه شده است.
            </span>
          </div>
        </div>
      )}
      {comments?.length > 0 && (
        <div className="flex flex-col items-center md:flex-row md:justify-between md:gap-4">
          <div className="w-full">
            <div className="flex flex-row justify-between">
              <h2 className="text-subtitle-1 md:text-headline-6">
                نظرات مسافران
              </h2>
              {(comments?.length ?? 0) >= 5 && (
                <Button
                  color="secondary"
                  onClick={toggleModal.bind(null, true)}
                  size="small"
                  variant="outline"
                >
                  همه نظرات
                </Button>
              )}
            </div>
            <div className="text-caption text-on-surface-medium-emphasis pb-4 pt-1 md:pb-0 md:pt-2">
              {/*{"در صورت اقامت در این اقامتگاه نظر و امتیاز خود را ثبت کنید تا دیگران با اطمینان بیشتری اقامتگاه مناسب برای سفرشان را انتخاب کنند‌."}*/}
            </div>
          </div>
          {/*<Button*/}
          {/*  color="secondary"*/}
          {/*  size="small"*/}
          {/*  variant="outline"*/}
          {/*>*/}
          {/*  ثبت دیدگاه*/}
          {/*</Button>*/}
        </div>
      )}
      {comments
        ?.slice(0, 5)
        .map((comment) => <ReserveComment key={comment?.id} {...comment} />)}
      <ReserveCommentPopup
        hotelTitle={hotelTitle}
        comments={comments}
        filters={filters}
        isLoading={isLoading}
        lastReviewId={lastReviewId}
        onClose={toggleModal.bind(null, false)}
        onLoadFilter={onLoadFilter}
        onLoadMore={onLoadMore}
        open={open}
        rate={rate}
      />
      {(comments?.length ?? 0) >= 5 && (
        <Button
          variant="round-outline"
          color="neutral"
          text="مشاهده نظرات بیشتر"
          onClick={toggleModal.bind(null, true, true)}
        />
      )}
    </div>
  );
};
export const ReserveCommentsLayout = memo(Component, deepCompare);
